import { useState } from 'react';
import LinkReviewIcon from '../../assets/customIcons/linkReviewIcon';
import ReassignIcon from '../../assets/customIcons/reassignIcon';
import ReviewFormIcon from '../../assets/customIcons/reviewFormIcon';
import TrashcanIcon from '../../assets/customIcons/trashcanIcon';
import BulkReassignReview from '../AssignReviewModal/BulkReassignReview';
import ReassignReview from '../AssignReviewModal/ReassignReview';
import ButtonDropdown from '../core/ButtonDropdown/ButtonDropdown';

const AssignmentsButton = ({
	item,
	isBulk = false,
	disabled = false,
	stageID,
	handleAlert,
	stages,
	resetSelection,
	outerTableRef
}) => {
	const [isReassigning, setIsReassigning] = useState();

	const handleOpenReassignModal = (choice) => {
		setIsReassigning(choice);
	};

	const addStageButton = {
		title: isBulk ? 'Bulk Manage Assignments' : 'Manage Assignments',
		id: 198567,
		tipPlacement: 'left',
		variant: 'outlined',
		marginBottom: '0px',
		popperPlacement: 'bottom-end',
		tipTitle: '',
		width: 'fit-content',
		zIndex: 10000,
		options: [
			{
				title: 'Reassign & Keep Content',
				endIcon: (
					<div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
						<ReassignIcon />
						<ReviewFormIcon />
					</div>
				),
				disabled: disabled,
				onClick: () => handleOpenReassignModal('reassign & keep')
			},
			{
				title: 'Reassign & Delete Content',
				endIcon: (
					<div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
						<ReassignIcon />
						<TrashcanIcon />
					</div>
				),
				disabled: disabled,
				onClick: () => handleOpenReassignModal('reassign & delete')
			},
			{
				title: 'Unassign & Delete Content',
				endIcon: (
					<div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
						<LinkReviewIcon />
						<TrashcanIcon />
					</div>
				),
				disabled: disabled,
				onClick: () => handleOpenReassignModal('unassign & delete')
			}
		]
	};

	return (
		<>
			<ButtonDropdown data={addStageButton} />
			{isReassigning && !isBulk && (
				<ReassignReview
					item={item}
					openModal={isReassigning}
					type={isReassigning}
					closeModal={() => setIsReassigning(false)}
					stageID={stageID}
				/>
			)}
			{isReassigning && isBulk && (
				<BulkReassignReview
					item={item}
					openModal={isReassigning}
					type={isReassigning}
					closeModal={() => setIsReassigning(false)}
					stageID={stageID}
					handleAlert={handleAlert}
					stages={stages}
					resetSelection={resetSelection}
					outerTableRef={outerTableRef}
				/>
			)}
		</>
	);
};

export default AssignmentsButton;
